<script setup>
import { onMounted } from "vue";

const props = defineProps({
  loteStore: Object,
  prorrogaModal: Object,
});

function cerrarModal() {
  props.prorrogaModal.hide();
}

function subirOferta() {
  props.loteStore.incrementarOferta();
  cerrarModal();
}

onMounted(() => {
  const modalEl = document.getElementById("prorrogaModal");
  if (modalEl) {
    modalEl.addEventListener("hidden.bs.modal", () => {});
  }
});

</script>


<template>
  <div class="modal fade" id="prorrogaModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center p-4 pt-5 pb-5 p-md-5 position-relative">
        <!-- Botón de cierre -->
        <button type="button"
          class="position-absolute top-0 end-0 m-2 me-2 bg-soft-grey border-0 rounded-circle d-flex align-items-center justify-content-center"
          style="width: 40px; height: 40px;" @click="cerrarModal" aria-label="Close">
          <span class="fs-global-iconos mb-1">&times;</span>
        </button>

        <!-- Icono de advertencia -->
        <div class="d-flex align-items-center justify-content-start mb-3 gap-2">
            <div class="icono-alerta rounded-circle bg-soft-orange-ff d-flex align-items-center justify-content-center"
            style="border-radius: 50%;">
                <i class="fas fa-exclamation text-soft-orange fs-global-iconos"></i>
            </div>

            <h5 class="text-soft-orange fw-bold mb-0 fs-global-titulos text-start">
                Alguien ofertó antes del cierre de lote
            </h5>
        </div>


        <!-- Mensaje dinámico -->
        <h6 class="text-black mt-2 mb-4 fs-global-contenido text-start fw-400">
          Extendimos <span class="text-soft-orange">5 minutos</span> más el tiempo de toma de ofertas.
        </h6>

        <!-- Botón para subir oferta -->
        <button class="btn btn-soft-orange fw-bold w-100 text-white" @click="subirOferta">
          Ofertar
        </button>
      </div>
    </div>
  </div>
</template>
